import React from "react";

import { Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";

import TextError from "./TextError";

import "./customDatePicker.css";

function FormikDatePicker(props) {
  const { name, ...rest } = props;

  return (
    <div className="form-control">
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form;
          const { value } = field;

          return (
            <div className="customDatePicker">
              <DatePicker
                id={name}
                {...field}
                {...rest}
                selected={value}
                // dateFormat="dd/MM/yyyy"
                placeholderText="Data *"
                onChange={(date) => {
                  setFieldValue(name, date);
                }}
              />
            </div>
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default FormikDatePicker;
